import clsx from "clsx";
import { twMerge } from "tailwind-merge";

const Divider = ({ onlySpace }: { onlySpace?: boolean }) => (
  <hr
    className={twMerge(
      clsx("flex w-full", {
        "text-yellow-light": !onlySpace,
      })
    )}
  />
);
export default Divider;
